<div class="footer-pagination">
  <div class="footer-pagination__entries d-flex">
    <div class="totalEntryCount">
      <p>Total - {{ totalElements | number: '1.0' : 'en-US' }}</p>
    </div>
    <select
      name="pages"
      [(ngModel)]="numberOfPages"
      class="footer-pagination__select bg-primary"
      (ngModelChange)="getMoreItemsPerPage()"
    >
      <option *ngFor="let opt of pageOptions" id="{{ opt }}" [ngValue]="opt">{{ opt }}</option>
    </select>
  </div>
  <div class="footer-pagination__pagination">
    <pagination
      id="emailTempPagination"
      [(ngModel)]="currentPage"
      [itemsPerPage]="numberOfPages"
      [totalItems]="totalElements"
      [customPreviousTemplate]="prevTemplate"
      [customNextTemplate]="nextTemplate"
      (pageChanged)="pageChanged($event)"
      [maxSize]="5"
    >
    </pagination>

    <ng-template #nextTemplate let-disabled="disabled" let-currentPage="currentPage">
      <ng-container *ngIf="!disabled">
        <i class="fas chevron fa-chevron-right"></i>
      </ng-container>
      <ng-container *ngIf="disabled">
        <i class="fas chevron fa-chevron-right"></i>
      </ng-container>
    </ng-template>
    <ng-template #prevTemplate let-disabled="disabled" let-currentPage="currentPage">
      <ng-container *ngIf="!disabled"><i class="fas chevron fa-chevron-left"></i> </ng-container>
      <ng-container *ngIf="disabled">
        <i class="fas chevron fa-chevron-left"></i>
      </ng-container>
    </ng-template>
  </div>
</div>
